goog.provide('el8.appchart.visitNote2.main');

goog.require('el8.template.appchart.visitNote2');

el8.appchart.visitNote2.main = (function() {
  var that = {};

  var container = $('#third-pane-container');
  
  var CONTAINER_ELEMENT_ID = 'react-visit-note-2-container';

  var openNoteId = null;

  $.extend(that, {
    getOpenNoteId: function() {
      return openNoteId;
    },

    show: function (props) {
      openNoteId = props.noteId;

      container.append(el8.template.appchart.visitNote2.container());
      container.show();
      el8React.render.visitNote2(CONTAINER_ELEMENT_ID, props);
    },

    close: function () {
      el8React.render.unmount(CONTAINER_ELEMENT_ID);
      container.empty().hide();

      openNoteId = null;
    },
  });

  return that;
})();